import qs from "qs";
import { IMasterDataInput, IMasterDataListResponse, IMasterDataResponse } from "../interfaces/master-data";
import authBaseAxios from "../utils/api";

export const MasterDataServices = {
  getAllByType: (type: string) => {
    return authBaseAxios.get(`master-data?type=${type}`);
  },
  getList: (params?: any): Promise<IMasterDataListResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`master-data/list?${queryString}`);
  },

  create: (body: IMasterDataInput): Promise<IMasterDataResponse> => {
    return authBaseAxios.post("master-data", body);
  },

  update: (id: string, body: IMasterDataInput): Promise<IMasterDataResponse> => {
    return authBaseAxios.put(`master-data/${id}`, body);
  },
};
